import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    DateField,
    SelectInput,
    FunctionField,
} from "react-admin";
import { Box } from "@mui/material";
import StatusField from "../../components/StatusField";
import ResourceStatusHeader from "../../components/ResourceStatusHeader";
import ValidateButton from "./ValidateButton";
import RejectButton from "./RejectButton";
import { useResourceSearchFilter } from "../../hooks/useResourceSearch";

const SubjectVariantFilters = [
    <SelectInput
        key="status"
        source="status"
        label="Statut"
        alwaysOn
        choices={[
            { id: "PENDING", name: "PENDING" },
            { id: "VALIDATED", name: "VALIDATED" },
            { id: "REJECTED", name: "REJECTED" },
        ]}
    />,
];

const getVariantLabel = (record) =>
    record?.variantLabel ||
    record?.label ||
    record?.value ||
    record?.variant?.value ||
    "—";

const getSubjectAuthor = (record) =>
    record?.subjectCreatedByUsername ||
    record?.subjectUsername ||
    record?.subject?.username ||
    "—";

const getVariantAuthor = (record) =>
    record?.createdByUsername ||
    record?.variantAuthor ||
    record?.createdBy ||
    "—";

export default function SubjectVariantList() {
    const searchFilter = useResourceSearchFilter("subject-variants");

    return (
        <>
            <ResourceStatusHeader
                resource="subject-variants"
                title="Variantes de subject"
                subtitle="Totaux par statut"
            />
            <List
                exporter={false}
                perPage={25}
                sort={{ field: "createdAt", order: "DESC" }}
                filters={SubjectVariantFilters}
                filter={searchFilter}
                title="Subject Variants"
            >
                <Datagrid bulkActionButtons={false}>
                    <TextField source="id" label="ID" />
                    <TextField source="subjectId" label="Subject UUID" />
                    <TextField source="subject" label="Subject" />
                    <FunctionField label="Variante" render={getVariantLabel} />
                    <FunctionField label="Auteur subject" render={getSubjectAuthor} />
                    <FunctionField label="Auteur variante" render={getVariantAuthor} />
                    <StatusField source="status" label="Statut" />
                    <DateField source="createdAt" label="Créé le" showTime />
                    <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                        <ValidateButton />
                        <RejectButton />
                    </Box>
                </Datagrid>
            </List>
        </>
    );
}
